exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group.keyword[data-v-3db6d47e]{position:relative}.clear-keyword[data-v-3db6d47e]{position:absolute;bottom:1px;right:35px;z-index:9}.or[data-v-3db6d47e]{position:absolute;background-color:#fff;left:0;right:0;width:54px;margin:auto;top:5px;font-size:26px;text-transform:uppercase}", ""]);

// exports
